import { render, staticRenderFns } from "./Tipp.vue?vue&type=template&id=13cf7287&scoped=true"
import script from "./Tipp.vue?vue&type=script&lang=js"
export * from "./Tipp.vue?vue&type=script&lang=js"
import style0 from "./Tipp.vue?vue&type=style&index=0&id=13cf7287&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf7287",
  null
  
)

export default component.exports